<template>
  <section>
    <p class="title is-2">Categorías</p>
    <b-tabs v-model="tabActiva" size="is-medium">

      <b-tab-item label="Categorías" icon="archive">
        <categorias-component />
      </b-tab-item>
    </b-tabs>
  </section>
</template>
<script>
import CategoriasComponent from "./CategoriasComponent";
export default {
  name: "MarcasCategorias",
  components: { CategoriasComponent },

  data: () => ({
    tabActiva: 0,
  }),
};
</script>